import { KeyboardSeparator } from "@ppb/the-wall-common/types";
import type { BetslipDecimalSeparator } from "../contract";

/**
 * Map the contract's decimal separator onto the keyboard's own enum.
 *
 * `KeyboardSeparator` is a presentation type owned by `@ppb/the-wall-common`, so it
 * stays on this side of the boundary: the contract carries a plain `"," | "."` and
 * the view layer converts.
 *
 * @param {BetslipDecimalSeparator} separator Separator supplied by the host through the contract
 * @returns {KeyboardSeparator} The equivalent keyboard separator
 */
export const toKeyboardSeparator = (separator: BetslipDecimalSeparator): KeyboardSeparator =>
  separator === "," ? KeyboardSeparator.Comma : KeyboardSeparator.Dot;
